import { useEffect, useState } from "react";
import { listConversations, deleteConversation } from "../lib/api";
import type { AppConfig, Conversation } from "../types";

interface Props {
  config: AppConfig;
  current: string | null;
  onOpen: (id: string) => void;
}

export function ConversationList({ config, current, onOpen }: Props) {
  const [items, setItems] = useState<Conversation[]>([]);
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function carregar() {
    setBusy(true);
    setErr(null);
    try {
      const r = await listConversations(config);
      setItems(r.items);
    } catch (e: any) {
      setErr(e.message || String(e));
    } finally {
      setBusy(false);
    }
  }

  useEffect(() => { carregar(); }, [config]);

  async function apagar(id: string) {
    if (!confirm("Apagar esta conversa? (irreversível)")) return;
    await deleteConversation(config, id);
    setItems((prev) => prev.filter((x) => x.id !== id));
  }

  return (
    <div className="conv-list">
      <div className="head">
        <h2>Conversas</h2>
        <button onClick={carregar} disabled={busy}>↻ atualizar</button>
      </div>
      {err && <div className="error">⚠ {err}</div>}
      {items.length === 0 && !busy && <div className="empty">Nenhuma conversa ainda.</div>}
      <ul>
        {items.map((c) => (
          <li key={c.id} className={current === c.id ? "active" : ""}>
            <div className="meta">
              <span className="agent">{c.agent_id}</span>
              <span className="date">{new Date(c.updated_at).toLocaleString("pt-BR")}</span>
            </div>
            <div className="title">{c.title}</div>
            <div className="actions">
              <button onClick={() => onOpen(c.id)}>abrir</button>
              <button onClick={() => apagar(c.id)} className="btn-danger">apagar</button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
